var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.74984C11.25 4.4402 10.6903 4.99984 10 4.99984C9.30967 4.99984 8.75 4.4402 8.75 3.74984C8.75 3.05948 10 1.6665 10 1.6665C10 1.6665 11.25 3.05948 11.25 3.74984Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5V7.5",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7236 11.6667C16.0276 11.6667 17.0846 10.7339 17.0846 9.58333C17.0846 8.43275 16.0276 7.5 14.7236 7.5H5.27908C3.97508 7.5 2.91797 8.43275 2.91797 9.58333C2.91797 10.7339 3.97508 11.6667 5.27908 11.6667C6.42137 11.6667 7.42143 10.9509 7.64019 10C7.85896 10.9509 8.85905 11.6667 10.0013 11.6667C11.1436 11.6667 12.1436 10.9509 12.3624 10C12.5812 10.9509 13.5812 11.6667 14.7236 11.6667Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 11.6665L4.60204 13.8162C5.03907 15.9805 5.25759 17.0627 5.99804 17.6979C6.73849 18.3332 7.78137 18.3332 9.86714 18.3332H10.1355C12.2212 18.3332 13.2641 18.3332 14.0046 17.6979C14.7451 17.0627 14.9636 15.9805 15.4006 13.8162L15.8346 11.6665",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdate);
export default __webpack_public_path__ + "static/media/birthdate.846ed948c8ce498e908afbce8568beb5.svg";
export { ForwardRef as ReactComponent };